module.exports = __webpack_public_path__ + "static/media/academic smart final icon.fce91c6b.svg";